import Item from './Item'
import AlbumOrderSummary from '../../LabOrderDetails/LabOrderDetailsInformation/OrderSummary/AlbumOrderSummary'
import { isMultiOpeningPrintSizeName } from '../../../lib/utils'

const OrderSummary = ({ lineItems, onUpdateQty, onUpdateMultiOpeningQty, onDelete, onDeleteAlbum, onDeleteMultiOpening, onClearCart }) => (
  <div className="container-rightside-order-summary no-margin">
    <div className="heading-container margin-bottom">
      <div className="grid-order-icons">
        <h2 className="heading-title right-margin">Order Review</h2>
      </div>
      {lineItems?.length > 0 && (
        <button
          type='button'
          className='_2nd-button main smaller tranparent w-inline-block'
          style={{ margin: 0 }}
          onClick={onClearCart}
        >
          Clear Cart
        </button>
      )}
    </div>

    <div
      className="w-layout-grid grid-element-order-summary head white smaller number"
      style={{ gridTemplateColumns: '33px 65px 140px 110px 140px 140px 55px 60px' }}
    >
      <div id="w-node-c769d59e-763a-a11d-1b07-716415342c00-69e80a54" className="heady center">
        <div>#</div>
      </div>
      <div className="heady print-details">
        <div>Image</div>
      </div>
      <div className="heady">
        <div>Print Details</div>
      </div>
      <div className="heady center">
        <div>Finish Type</div>
      </div>
      <div className="heady center">
        <div>Details</div>
      </div>
      <div className="heady center">
        <div>Notes</div>
      </div>
      <div className="heady center">
        <div>Qty</div>
      </div>
      <div className="heady center">
        <div>Total</div>
      </div>
    </div>

    <div className="w-layout-grid grid-order-summary-container no-scroll">
      {lineItems?.filter((lineItem) => lineItem?.type === 'api_lab_order_line_item' || lineItem?.type === 'multi_openings_line_item')
        ?.map((lineItem, index) => (
          <Item
            key={lineItem.id}
            lineItem={{ ...lineItem.attributes, isMultiOpening: lineItem?.type === 'multi_openings_line_item' || isMultiOpeningPrintSizeName(lineItem.attributes?.printSizeAttributes?.printSize) }}
            position={index}
            onUpdateQty={onUpdateQty}
            onUpdateMultiOpeningQty={onUpdateMultiOpeningQty}
            onDelete={onDelete}
            onDeleteMultiOpening={onDeleteMultiOpening}
          />
        ))}
      <AlbumOrderSummary
        showAlbumActions
        albumOrderDetailsProp={lineItems?.filter((lineItem) => lineItem?.type === 'album_order_detail') ?? []}
        onDeleteAlbum={onDeleteAlbum}
      />
    </div>
  </div>
)

export default OrderSummary
